<template>
  <div class="flex-page">
    <div class="content flex-1">
      <h4 class="title">注销后，您将放弃以下权益：</h4>
      <p>
        1.交易记录、问诊记录、处方记录将被删除，请确保所有交易已完成且无争议。账户删除后交易可能产生的退换货、维权等权益将视作自动放弃。
      </p>
      <p>2.您的身份信息、账户信息、各类补贴等权益将被清空且无法恢复。</p>
      <p>3.该账号将无法登陆智云医道，原有的交易记录、处方记录、病例管理等将被清空且无法恢复。</p>
      <br />
      <br />

      <p class="section-title">注销协议</p>

      <p>1.您所申请注销的账号应当是您依照本协议的约定注册并实际使用的本人账号。</p>
      <p>2.您应确保您有权决定该账号的注销事宜，不侵犯任何第三方权益，因此引发的任何法律责任，将全部由您本人承担。</p>
      <p>
        3.在您申请注销智云医道账号前，您应确保该账号处于正常状态，且在注销申请提起时该账号下无未完结交易、无进行中的投诉纠纷或处罚、亦无任何拖欠的款项及其他因交易产生的欠款等，并符合其他智云医道所要求的一切账户注销条件。
      </p>
      <p>
        4.您知晓账号注销将导致本公司终止为您提供服务,用户协议约定的双方的权利义务将终止（依协议其他条款约定不得终止的或依其性质不能终止的除外），并将发生以下结果：
      </p>

      <p>A、您将无法再次使用该账号登录智云医道进行任何操作</p>
      <p>B、您的账号内所有的历史记录信息将被清除并无法再次找回；</p>
      <p>C、您的账号内所获得的任何优惠信息都将作废。</p>

      <p>5.您应当依照本公司规定的提示进行账号注销，且账号注销申请一经提交立即生效。</p>
    </div>

    <div class="footer van-hairline--top">
      <div class="checkbox">
        <van-checkbox icon-size="16" v-model="checked"><span>已同意并阅读</span></van-checkbox>
        <span class="link-btn" @click="processLink">《账号注销须知》</span>
      </div>
      <div class="btn">
        <van-button style="width: 100%" color="#1E8DFF" @click="confirmLogOff">确认注销</van-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      checked: false
    };
  },
  methods: {
    confirmLogOff() {
      if (!this.checked) {
        this.$toast('请确认阅读并同意《账号注销须知》');
        return;
      }

      this.$fetch.logOffPreCheck().then((res) => {
        if (res.code && !res.success) {
          switch (res.code) {
            case 'FORBIDDEN_LOGOFF_ORDER':
              // 还有订单未完成，不能注销
              this.alertMsg(res);
              break;

            case 'FORBIDDEN_LOGOFF_ZYJK':
              // 还有智云健康订单未完成，不能注销
              this.alertMsg(res);
              break;

            case 'FORBIDDEN_LOGOFF_CP':
              // 注册城市合伙人，需要联系客服注销
              this.confirmMsg(res, '联系客服').then(() => {
                window.location.href = `tel: 400-921-6690`;
              });
              break;

            case 'LOGOFF_WARNNING':
              // 一般情况，可以注销账号 但是需要提示用户一下
              this.confirmMsg(res).then(() => {
                this.goLogOffCode();
              });
              break;

            default:
              this.alertMsg(res);
              break;
          }
          return;
        }
        this.goLogOffCode();
      });
    },
    goLogOffCode() {
      this.$router.push({
        name: 'logOffCode',
        query: {
          ...this.$route.query
        }
      });
    },
    alertMsg(res = { message: '' }, confirmTxt = '确认') {
      return this.$dialog.alert({
        title: '提示',
        confirmButtonText: confirmTxt,
        message: res.message
      });
    },
    confirmMsg(res = { message: '' }, confirmTxt = '确认') {
      return this.$dialog.confirm({
        title: '提示',
        confirmButtonText: confirmTxt,
        message: res.message || ''
      });
    },
    processLink() {
      window.location.href = 'https://static.91jkys.com/kaer/zyydzhzxxz/index.html#/';
    }
  }
};
</script>
<style lang="less" scoped>
.flex-page {
  height: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  .flex-1 {
    flex: 1;
    overflow: auto;
  }
  .content {
    background: #ffffff;
    padding: 20px 16px;
    color: #262626;
    h4.title {
      font-size: 24px;
      margin-bottom: 12px;
    }
    p {
      font-size: 16px;
      line-height: 23px;
      padding-bottom: 12px;
    }
  }
  .footer {
    background: #ffffff;
    .btn {
      padding: 8px 16px;
      padding-top: 0;
    }
  }
}
.checkbox {
  display: flex;
  padding: 16px;
  flex-direction: row;
  align-items: center;
  span {
    font-size: 14px;
    line-height: 1;
    color: #262626;
    &.link-btn {
      color: #1e8dff;
    }
  }
}
</style>